


import React, { useEffect, useState, useRef ,useCallback} from 'react'
import { Link } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios'
import _ from 'lodash'
import { BASE_URL } from '../Config/Base';
import { BASE_URL2 } from '../Config/Base';
import {IMG_URL2 } from '../Config/Base';
import loader from '../Assets/Images/Loading_icon.gif'
import { get } from 'jquery';

// import { ClipLoader,PulseLoader,FadeLoader} from 'react-spinners';


const FoundSectionETMain = () => {

  const [fileA, setFileA] = useState();
  const [fileB, setFileB] = useState();
  const [display, setDisplay] = useState(true)
  const [edit, setEdit] = useState(true)
  const [del, setDel] = useState(true)
  const [pop, setpop] = useState(false);

  const handleFileChange = (e) => {

    setFileA(e.target.files[0]);

  };
  const handleFileChange1 = (e) => {

    setFileB(e.target.files[0]);
       
    setFileA(e.target.value)

    document.getElementById("foundchangeinput").reset()
  };

  function AddAddress() {

    var evtn = document.getElementById('evtname').value
    var evtd = document.getElementById('evtdate').value
    var evtl = document.getElementById('evtlocation').value
    var evtp = document.getElementById('evtplace').value
    var evts = document.getElementById('evtstory').value


    

    if (!evtn) {

      document.getElementById("EventNameErr").innerHTML = "This Field is Required";

    }
    else if (evtn) {

      document.getElementById("EventNameErr").innerHTML = " ";

    }

    if (!evtd) {

      document.getElementById("EventDateErr").innerHTML = "This Field is Required";

    }
    else if (evtd) {

      document.getElementById("EventDateErr").innerHTML = " ";

    }


    if (!evtl) {

      document.getElementById("EventLocationErr").innerHTML = "This Field is Required";

    }
    else if (evtl) {

      document.getElementById("EventLocationErr").innerHTML = " ";

    }


    if (!evtp) {

      document.getElementById("EventPlaceErr").innerHTML = "This Field is Required";

    }
    else if (evtp) {

      document.getElementById("EventPlaceErr").innerHTML = " ";

    }

    if (!evts) {

      document.getElementById("EventStoryErr").innerHTML = "This Field is Required";

    }
    else if (evts) {

      document.getElementById("EventStoryErr").innerHTML = " ";

    }

    // if (!fileA) {

    //   document.getElementById("EventImage_PathErr").innerHTML = "This Field is Required";

    // }
    // else if (fileA) {

    //   document.getElementById("EventImage_PathErr").innerHTML = " ";

    // }

    if (!fileB) {

      document.getElementById("EventFileNameErr").innerHTML = "This Field is Required";

    }
    else if (fileB) {

      document.getElementById("EventFileNameErr").innerHTML = " ";

    }

    if ( evtn && evtd && evtl && evtp && evts && fileB) {

      const body = {

        event_name: evtn,
        event_date: evtd,
        event_location: evtl,
        event_place: evtp,
        story: evts,
        notifn_status: 0,
        del_status: 0,
        fileName: fileB,


      }

      console.log('body', body);

      axios({

        method: "POST",
        url: `${BASE_URL}/FoundationMain/AddEvent`,
        data: body,
        headers: {
          "Content-Type": "multipart/form-data"

        }

      })

        .then((response) => {
          console.log(response.data);

          if (response.data.status === "Success") {

            alert("Add Successfully !");
            // toast.success("Content Added Successfully !");
            getEvent();
            document.getElementById('addressform-clear').reset();

          }


        })

        .catch(error => {
          console.log(error);
          alert("Failed to Add !");
          //toast.warning("Added failed !")

        })
    }
  }


  const token = JSON.parse(localStorage.getItem('usertoken'));
  const [Event, setEvent] = useState([])

  const pageSize = 3;

  const [paginatedPosts, setpaginatedPosts] = useState();


  useEffect(() => {
    setpop(true);
    getEvent()
    getRoleData();
    getRole();
    document.getElementById('section-main').style.display = "none";

    setTimeout(() => {
      setpop(false);

      getUserRole();
      document.getElementById('section-main').style.display = "block";

    }, 1000)

  }, [])

  function getEvent() {


    console.log("Token", token)
    fetch(`${BASE_URL}/FoundationMain/GetEvent`, {

      method: 'GET',

      headers: {

        "Content-type": "application/json",

        "Accept": "application/json",

        // "Authorization": "Bearer " + `${token}`,

        "Access-Control-Allow-Headers": "Access-Control-Request-Headers "

      },

      //body:JSON.stringify(data)

    }).then(response => response.json())

      .then(data => {
        console.log("Data", data)
        setEvent(data);
        setpaginatedPosts(_(data).slice(0).take(pageSize).value());
        localStorage.setItem("paginationDataEvents", JSON.stringify(data));  
      }
      );

    console.log("check", Event)
  }



  function ConfirmDelete(Id) {

    SelectEvent(Id);
    document.getElementById("modalDeleteForm").style.display = "block";
    document.getElementById("DisplayEditPop").style.display = "none";
  }


  function Canceldel() {
    document.getElementById("modalDeleteForm").style.display = "none";
  }


  function closedelForm() {
    document.getElementById("modalDeleteForm").style.display = "none";

  }

  //  delete status //


  function EventDeleteStatus(Id) {
    //const token = JSON.parse(localStorage.getItem('usertoken'));

    // var ans=window.confirm('Are you sure want to delete this Section?');
    // if(ans==true)
    // {
    const body = {
      id: Id
    }
    console.log('check', body)
    axios({

      method: "POST",
      url: `${BASE_URL}/FoundationMain/EventDeleteStatus`,
      data: body,
      headers: {
        "Content-Type": "application/json",
        //"Authorization": "Bearer " + `${token}`

      }

    })
      .then((response) => {
        console.log(response.data);
        alert("Delete Successfully !");
        //  toast.success("Event Deleted Successfully !", {
        //   position: "top-center",
        //   autoClose: 3200,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        //   className: 'toast-message'
        //   });
        setTimeout(() => {

          getEvent();
          closedelForm();

        }, 1000);


      })

      .catch(error => {
        console.log(error);
        alert("Failed to Delete !")
        // toast.warning("Failed to Delete")   
      })


  }


  /*----Get select to the particular Id----*/
  const [EditEvent, SetEditEvent] = useState([]);

  function SelectEvent(Id) {

    

    document.getElementById("DisplayEditPop").style.display = "block";

    const body =
    {

      id: Id
    }
    console.log('body', body);


    axios({
      method: "POST",
      url: `${BASE_URL}/FoundationMain/SelectEvent`,
      data: body,
      headers: {
        "Content-type": "application/json",
        // "Authorization": "Bearer " + `${token}`
      }
    })


      .then((response) => {
        console.log(response.data);


        SetEditEvent(response.data);

      })
      .catch(error => {
        console.log(error);

      })

  }


  function closeForm() {


    
    document.getElementById('DisplayEditPop').style.display = "none";
    document.getElementById('foundform').reset();

    document.getElementById("EventErr").innerHTML = " ";
    document.getElementById("EventErrA").innerHTML = " ";
    document.getElementById("EventErrB").innerHTML = " ";
    document.getElementById("EventErrC").innerHTML = " ";
    document.getElementById("EventErrD").innerHTML = " ";

  }


  /*----EditSection----*/

  function updateEvent(Id) {

    // const token = JSON.parse(localStorage.getItem('usertoken'));

    var eventname = document.getElementById('EVName').value;
    var eventdate = document.getElementById('EVDate').value;
    var eventloc = document.getElementById('EVLoc').value;
    var eventplace = document.getElementById('EVLoc').value;
    var evStory = document.getElementById('EVStory').value;
    var OldImage = document.getElementById("oldEventFound").value

    if (!eventname) {

      document.getElementById("EventErr").innerHTML = "EventName Required";

    }

    else if (eventname) {
      document.getElementById("EventErr").innerHTML = " ";

    }

    if (!eventdate) {

      document.getElementById("EventErrA").innerHTML = "EventDate Required";

    }
    else if (eventdate) {

      document.getElementById("EventErrA").innerHTML = " ";

    }

    if (!eventloc) {

      document.getElementById("EventErrB").innerHTML = "EventLoaction Required";

    }
    else if (eventloc) {

      document.getElementById("EventErrB").innerHTML = " ";

    }


    if (!eventplace) {

      document.getElementById("EventErrC").innerHTML = "Event Place Required";

    }
    else if (eventplace) {

      document.getElementById("EventErrC").innerHTML = " ";

    }


    if (!evStory) {

      document.getElementById("EventErrD").innerHTML = "EventStory Required";

    }
    else if (evStory) {

      document.getElementById("EventErrD").innerHTML = " ";

    }

    // if (!fileB) {

    //   document.getElementById("EventErrE").innerHTML = "Image Required";

    // }
    // else if (fileB) {

    //   document.getElementById("EventErrE").innerHTML = " ";

    // }



    if (eventname && eventdate && eventloc && eventplace && evStory) {

      const body = {

        id: Id,
        event_name: eventname,
        event_date: eventdate,
        event_location: eventloc,
        event_place:eventplace,
        // event_main_location: eventmainloc,
        story: evStory,
        fileName:fileB,
        oldImage:OldImage
      }
      // console.log(body);


      axios({

        method: "POST",

        url: `${BASE_URL}/FoundationMain/EditEvent`,
        data: body,
        headers: {

          'Content-Type': 'multipart/form-data',
          
          // "Authorization": "Bearer " + `${token}`

        }

      })

        .then((response) => {
          console.log(response.data);
          if (response.data.status === "Error") {

            toast.error("InCorrect")
          }

          else if (response.data.status === "Success") {
            alert("Update Successfully !");
            setFileA()
            setFileB()
            document.getElementById('DisplayEditPop').style.display = "none";
           
            setTimeout(() => {

             
              getEvent()
              closeForm()
            }, 2000);
          }

        })

        .catch(error => {
          console.log(error);
          alert("Failed to Update !");
        })
    }
  }




  function getRoleData() {


    let UserRole = localStorage.getItem("Role");

    const body = {

      roles: UserRole

    }
    console.log(body);

    const token = JSON.parse(localStorage.getItem('usertoken'));

    axios({
      method: "POST",
      url: `${BASE_URL}/Foundation/GetUserLoginRoles`,
      data: body,
      headers: {
        'Content-Type': 'application/json',
        "Authorization": "Bearer " + `${token}`
      }

    })
      .then((response) => {
        console.log(response.data);
        localStorage.setItem("loginUserRoleaction", JSON.stringify(response.data));

      })

  }


  function getRole() {

    const token = JSON.parse(localStorage.getItem('usertoken'));

    fetch(`${BASE_URL}/Foundation/FoundationGetRoles`, {
      method: 'GET',

      headers: {

        "Content-type": "application/json",

        "Accept": "application/json",

        "Authorization": "Bearer " + `${token}`,

        "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
      },


    })

      .then(response => response.json())


      .then(data => {
        console.log("Role", data)
        //  setRoletable(data)
        localStorage.setItem("Data", JSON.stringify(data));
      });
  }



  function getUserRole() {

    /**----getroleAction---- */
    let Tcrole = localStorage.getItem("loginUserRoleaction");
    let roledata = JSON.parse(Tcrole);
    let role = roledata.map((e) => e.roleAction);
    console.log(role);

    let roles = role.toString();
    let add = roles.includes('Add')
    console.log(add)

    let view = roles.includes('View')
    console.log(view)

    let edit = roles.includes('Edit')
    console.log(edit)

    let del = roles.includes('Delete')
    console.log(del)

 

    let empty = roles.includes('')
    console.log(empty)


    let roleid = localStorage.getItem('RoleId')
    let id = roleid.includes('01')
    console.log(id)


    if(id==true&&empty==true&&add==false&&view==false&&edit==false&&del==false)
    {
      setDisplay(true);
      setEdit(true);
      setDel(true);
    
    }
    if(id==false&&empty==true&&add==false&&view==false&&edit==false&&del==false)
    {
      setDisplay(false);
      setEdit(false);
      setDel(false);
      document.getElementById('Foundsectiontable').style.display ="none";
      document.getElementById('Add-section-btn').style.display ="none";
      document.getElementById('evtname').style.display ="none";
      document.getElementById('evtdate').style.display ="none";
      document.getElementById('evtlocation').style.display ="none";
      document.getElementById('evtstory').style.display ="none";
      document.getElementById('evtplace').style.display ="none";
      document.getElementById('filechoose-input').style.display ="none";
      document.getElementById('Foundaction-err').innerHTML = 'Not Assign'
      document.getElementById('Foundaction-err').style.color = "red"
      document.getElementById('Foundaction-err').style.fontWeight = "bold"
      document.getElementById('Foundaction-err').style.alignItems = "center"
      document.getElementById('Foundaction-err').style. justifyContent = "center"
      document.getElementById('Foundaction-err').style. display= "flex"

     
    }

  

    if (view == true) {
      setDisplay(false);
      document.getElementById('Add-section-btn').style.display = "none";
      document.getElementById('evtname').style.display ="none";
      document.getElementById('evtdate').style.display ="none";
      document.getElementById('evtlocation').style.display ="none";
      document.getElementById('evtstory').style.display ="none";
      document.getElementById('evtplace').style.display ="none";
      document.getElementById('filechoose-input').style.display ="none";

    }
    if (add == true) {
      setDisplay(false);
      document.getElementById('Add-section-btn').style.display = "block";
      document.getElementById('evtname').style.display ="block";
      document.getElementById('evtdate').style.display ="block";
      document.getElementById('evtlocation').style.display ="block";
      document.getElementById('evtstory').style.display ="block";
      document.getElementById('evtplace').style.display ="block";
      document.getElementById('filechoose-input').style.display ="block";

    }
    if (edit == true) {
      setDisplay(true);
      setEdit(true)
      setDel(false)
      document.getElementById('Add-section-btn').style.display = "none";
      document.getElementById('evtname').style.display ="none";
      document.getElementById('evtdate').style.display ="none";
      document.getElementById('evtlocation').style.display ="none";
      document.getElementById('evtstory').style.display ="none";
      document.getElementById('evtplace').style.display ="none";
      document.getElementById('filechoose-input').style.display ="none";

    }

    if (del == true) {
      setDisplay(true);
      setEdit(false)
      setDel(true)
      document.getElementById('Add-section-btn').style.display = "none";
      document.getElementById('evtname').style.display ="none";
      document.getElementById('evtdate').style.display ="none";
      document.getElementById('evtlocation').style.display ="none";
      document.getElementById('evtstory').style.display ="none";
      document.getElementById('evtplace').style.display ="none";
      document.getElementById('filechoose-input').style.display ="none";

    }

    if (add == true && view == true && edit == true && del == true) {
      setDisplay(true);
      setEdit(true);
      setDel(true);
      document.getElementById('Add-section-btn').style.display = "block";
      document.getElementById('evtname').style.display ="block";
      document.getElementById('evtdate').style.display ="block";
      document.getElementById('evtlocation').style.display ="block";
      document.getElementById('evtstory').style.display ="block";
      document.getElementById('evtplace').style.display ="block";
      document.getElementById('filechoose-input').style.display ="block";

    }

    if (edit == true && del == true) {
      setDisplay(true);
      setEdit(true);
      setDel(true);
      document.getElementById('Add-section-btn').style.display = "none";
      document.getElementById('evtname').style.display ="none";
      document.getElementById('evtdate').style.display ="none";
      document.getElementById('evtlocation').style.display ="none";
      document.getElementById('evtstory').style.display ="none";
      document.getElementById('evtplace').style.display ="none";
      document.getElementById('filechoose-input').style.display ="none";
    }


    if (add == true && edit == true) {
      setDisplay(true);
      setEdit(true);
      setDel(false);
      document.getElementById('Add-section-btn').style.display = "block";
      document.getElementById('evtname').style.display ="block";
      document.getElementById('evtdate').style.display ="block";
      document.getElementById('evtlocation').style.display ="block";
      document.getElementById('evtstory').style.display ="block";
      document.getElementById('evtplace').style.display ="block";
      document.getElementById('filechoose-input').style.display ="block";
    }

    if (add == true && del == true) {
      setDisplay(true);
      setEdit(false);
      setDel(true);
      document.getElementById('Add-section-btn').style.display = "block";
      document.getElementById('evtname').style.display ="block";
      document.getElementById('evtdate').style.display ="block";
      document.getElementById('evtlocation').style.display ="block";
      document.getElementById('evtstory').style.display ="block";
      document.getElementById('evtplace').style.display ="block";
      document.getElementById('filechoose-input').style.display ="block";
    }

    if (add == true && edit == true && del == true) {
      setDisplay(true);
      setEdit(true);
      setDel(true);
      document.getElementById('Add-section-btn').style.display = "block";
      document.getElementById('evtname').style.display ="block";
      document.getElementById('evtdate').style.display ="block";
      document.getElementById('evtlocation').style.display ="block";
      document.getElementById('evtstory').style.display ="block";
      document.getElementById('evtplace').style.display ="block";
      document.getElementById('filechoose-input').style.display ="block";
    }


  }

            
  const LEFT_PAGE = "LEFT";
  const RIGHT_PAGE = "RIGHT";
  const range = (from, to, step = 1) => {
    let i = from;
    const range = [];
  
    while (i <= to) {
      range.push(i);
      i += step;
    }
  
    return range;
  };
   const [currentPage, setCurrentPage] = useState(1);

  let data = localStorage.getItem("paginationDataEvents")
  let transdata =  JSON.parse(data);
  let NUM_OF_RECORDS = transdata.length;
  let LIMIT = 5;
  
  const onPageChanged = useCallback(
  
    (event, page) => {
      event.preventDefault();
      setCurrentPage(page);
    },
    [setCurrentPage]
    
  );
  
  
  const currentData = transdata.slice(
    (currentPage - 1) * LIMIT,
    (currentPage - 1) * LIMIT + LIMIT
  );
  
  const Paginations = (props) => {
    const {
      totalRecords,
      pageLimit,
      pageNeighbours,
      onPageChanged,
      currentPage
    } = props;
    const [totalPages, setTotalPages] = useState(0);
    useEffect(() => {
      setTotalPages(Math.ceil(totalRecords / pageLimit));
    }, [setTotalPages]);
  
    const fetchPageNumbers = () => {
      const totalNumbers = pageNeighbours * 1 + 0;
      console.log(totalNumbers)
      console.log(pageNeighbours)
      const totalBlocks = totalNumbers + 2;
      console.log(totalBlocks)
  
      if (totalPages > totalBlocks) {
        const startPage = Math.max(2, currentPage - pageNeighbours);
        const endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);
  
        let pages = range(startPage, endPage);
  
        const hasLeftSpill = startPage > 2;
        const hasRightSpill = totalPages - endPage > 1;
        const spillOffset = totalNumbers - (pages.length + 1);
  
        switch (true) {
          case hasLeftSpill && !hasRightSpill: {
            const extraPages = range(startPage - spillOffset, startPage - 1);
            pages = [LEFT_PAGE, ...extraPages, ...pages];
            break;
          }
          case hasLeftSpill && hasRightSpill:
          default: {
            pages = [LEFT_PAGE, ...pages, RIGHT_PAGE];
            break;
          }
        }
        return [1, ...pages, totalPages];
      }
      return range(1, totalPages);
    };
  
  
    const pages = fetchPageNumbers() || [];
    return (
      <nav aria-label="Countries Pagination" id='foundnavpag'>
        <ul className="pagination">
          {pages.map((page, index) => {
            if (page === LEFT_PAGE)
              return (
                <li key={index} className="page-item">
                  <a
                    href="/"
                    className="page-link"
                    aria-label="Previous"
                    onClick={(e) => onPageChanged(e, pageNeighbours * 2 - 1)}
                  >
                    <span aria-hidden="true">&laquo;</span>
                  </a>
                </li>
              );
  
            if (page === RIGHT_PAGE)
              return (
                <li key={index} className="page-item">
                  <a
                    className="page-link"
                    href="/"
                    aria-label="Next"
                    onClick={(e) => onPageChanged(e, pageNeighbours * 2 + 1)}
                  >
                    <span aria-hidden="true">&raquo;</span>
                  </a>
                </li>
              );
  
            return (
              <li
                key={index}
                className={`page-item${currentPage === page ? " active" : ""}`}
              >
                <a
                  className="page-link"
                  href="/"
                  onClick={(e) => onPageChanged(e, page)}
                >
                  {page}
                </a>
              </li>
            );
          })}
        </ul>
      </nav>
    );
  };

  return (

    <div className='foundation-addmain'>

      <div className="foundation-addgrid-layout">
        <div className="foundation-addmain-top">
          <div className='foundation-addmain-back'>
            <Link to='/FoundSectionJS'><i class="fa fa-chevron-left" aria-hidden="true"></i></Link>
          </div>
          <span>Events</span>
        </div>
      </div>

      <span id="Foundaction-err"></span>


      {pop ? <div className='text-center'><img src={loader} alt="loader" id='loading-Indicator' /></div>
        : null}

      <div id='section-main'>


        <div className='foundation-ETtable-section'>
          {/* <div className="table_foundation-responsive "> */}


          <form id='addressform-clear' onSubmit={AddAddress}>
            <div className="modal-body mx-4">

              <div className='text-center'>
                {/* <h5>Contents</h5> */}
              </div>

              <br></br>

              <div className='col-sm-12'>

                <div className='row'>

                  {/* <div className='col-sm-5'>
                    <div className="md-form mb-0">
                      <input type="text" id="evtid" maxLength={4} placeholder='Id' />
                      <span id="EventIdErr" className='error'></span>
                    </div>
                  </div> */}

                  <div className='col-sm-5'>
                    <div className="md-form mb-0">
                      <input type="text" id="evtname" placeholder='Event Name' />
                      <span id="EventNameErr" className='error'></span>
                  </div>
                  </div>


                  <div className='col-sm-5'>
                    <div className="md-form mb-0">
                      <input type="date" id="evtdate" placeholder='Event Date' />
                      <span id="EventDateErr" className='error'></span>
                    </div>
                  </div>


                  <div className='col-sm-5'>
                    <div className="md-form mb-0">
                      <input type="text" id="evtlocation" placeholder='Event Location' />
                      <span id="EventLocationErr" className='error'></span>
                    </div>
                  </div>


                  <div className='col-sm-5'>
                    <div className="md-form mb-0">
                      <input type="text" id="evtplace" placeholder='Event Place' />
                      <span id="EventPlaceErr" className='error'></span>
                    </div>
                  </div>


                  <div className='col-sm-5'>
                    <div className="md-form mb-0">
                      <textarea type="text" id="evtstory" placeholder='Story' />
                      <span id="EventStoryErr" className='error'></span>
                    </div>
                  </div>


                  {/* <div className='col-sm-5'>
                    <div className="md-form mb-0">
                      <input type="file" placeholder='image_path' onChange={handleFileChange} id='filechoose-input' />
                      <span id="EventImage_PathErr" className='error'></span>
                    </div>
                  </div> */}

                  <div className='col-sm-5'>
                    <div className="md-form mb-0">
                      <input type="file" placeholder='fileName' onChange={handleFileChange1} id='filechoose-input' />
                      <span id="EventFileNameErr" className='error'></span>
                    </div>
                  </div>

                  {/* <div className='col-sm-2'> 
<div className="md-form mt-2">
<button className='foundation-Assign-button' id='Add-section-btn' type='submit'>ADD</button>
</div>
</div> */}

                </div>
              </div>
            </div>


            <div className='d-flex justify-content-center' style={{ marginRight: "120px" }}>
              <button className='foundation-Assign-button' id='Add-section-btn' type='submit'>ADD</button>
            </div>


          </form>



        </div>
        {/* </div> */}

        <br></br>

        <div className='foundationContent-table'>
          <div className="table_foundationContent-responsive " id="Foundsectiontable">

            {/* <div className='text-center'>
              <h5>Event Details</h5>
            </div> */}
            <table>
              <thead>
                <tr>
                  <th>Event Name</th>
                  <th>Event Date</th>
                  <th>Event Location</th>
                  <th>Event Place</th>
                  <th>Story</th>
                  <th>Image</th>

                  {display ? <th>Action</th> : null}
                </tr>
              </thead>
              <tbody>

                {currentData.map((e) => {
                  return <tr>
                    {/* <td>{e.id}</td> */}
                    <td>{e.eventName}</td>
                    <td>{e.eventDate}</td>
                    <td>{e.eventLocation}</td>
                    <td>{e.eventPlace}</td>
                    <td>{e.story}</td>
                    <td ><img src={e.fileName} style={{width:"55px",height:"55px"}}/></td>
                    {display ? <td className='text-center' style={{whiteSpace:"nowrap"}}>
                      {edit ? <span><i class="fa fa-pencil" aria-hidden="true" onClick={() => SelectEvent(e.id)} id="FoundEditicon"></i></span> : null} &nbsp;&nbsp;
                      {del ? <span><i class="fa fa-trash" aria-hidden="true" onClick={() => ConfirmDelete(e.id)} id="FoundDelicon" ></i></span> : null}
                    </td> : null}

                  </tr>
                })}


              </tbody>


            </table>



            <br></br>


            {transdata.length<=5? null:<div>{

            !paginatedPosts ? (""):(
            <Paginations
            totalRecords={NUM_OF_RECORDS}
            pageLimit={LIMIT}
            pageNeighbours={1}
            onPageChanged={onPageChanged}
            currentPage={currentPage}
          /> 
          )}
          </div>
}

          </div>
        </div>



        {/* DeletePopup */}

        <div className="foundation-pop-fade" id="modalDeleteForm" tabindex="-1" role="dialog">
          {EditEvent.map((e) => {
            return <div className="modal-dialog" role="document">
              <div className="modal-content" style={{marginTop:"280px"}}>
                <div className="modal-header text-center">
                  <h4 className="modal-title w-100 font-weight-bold">! Warning</h4>
                  <button type="button" className="close" onClick={closedelForm}>
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <form id='form'>

                  <div className="modal-body mx-3">

                    <div className="md-form mb-5">
                      <div className='text-center'>
                        <h5>Are you sure want to delete this Content?</h5>
                      </div>
                    </div>

                  </div>

                  <div className="modal-footer d-flex justify-content-center">
                    <button className="foundation-adduser-button" onClick={() => EventDeleteStatus(e.id)} type='submit'>Delete</button>
                    <button className="foundation-adduser-button" onClick={Canceldel} type='submit'>Cancel</button>
                  </div>
                </form>

              </div>
            </div>
          })}
        </div>

        {/* EditPopup */}

        <div className='foundation-pop-fade' id="DisplayEditPop">
          {EditEvent.map((e) => {
            return <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header text-center">
                  <h4 className="modal-title w-100 font-weight-bold">EDIT SECTION</h4>
                  <button type="button" className="close" onClick={closeForm}>
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <form id="foundform" onSubmit={() => updateEvent(e.id)}>
                  <div className="modal-body mx-3">
                    <div className="md-form mb-4">
                      <label>EventName</label>
                      <input type="text" id="EVName" defaultValue={e.event_name} />
                      <span id='EventErr' className='error'></span>
                    </div>

                    <div className="md-form mb-4">
                      <label>Event Date</label>
                      <input type="text" id="EVDate" defaultValue={e.event_date} />
                      <span id="EventErrA" className='error'></span>
                    </div>

                    <div className="md-form mb-4">
                      <label>Event Location</label>
                      <input type="text" id="EVLoc" defaultValue={e.event_location} />
                      <span id="EventErrB" className='error'></span>
                    </div>

                    <div className="md-form mb-4">
                      <label>Event Place</label>
                      <input type="text" id="EVLoc" defaultValue={e.event_place} />
                      <span id="EventErrC" className='error'></span>
                    </div>

                    <div className="md-form mb-4">
                      <label>Story</label>
                      <textarea type="text" id="EVStory" defaultValue={e.story} />
                      <span id="EventErrD" className='error'></span>
                    </div>


                    <div className="md-form ">
                    <label>Event Image</label>

                        {!fileB?<div>
                          <input type="file" style={{opacity:"0",position:"relative",top:"50px",left:"0px",zIndex:"1",top:"0"}} onChange={handleFileChange1}/>
                          <div style={{border:"1px solid lightgrey" ,padding:"1px 12px 1px 12px",borderRadius:"2px",marginTop:"-50px"}}>
         <input defaultValue={e.fileName}  id="oldEventFound"style={{border:"none",marginLeft:"84px",background:"transparent",position:"relative"}}/>
          <span style={{border:"1px solid black",backgroundColor:"#efefef",padding:"2px 2px 2px",borderRadius:"2px",position:"absolute",marginTop:"-38px"}}>Choose File</span>
          {/* &nbsp;<span >{e.fileName}</span> */}
          </div>

                        </div>
                        
                         :
                         
                         <div>
                          
                          <form id="foundchangeinput"><input type="file" style={{opacity:"0",position:"relative",top:"50px",left:"0px",zIndex:"1",top:"0"}} onChange={handleFileChange1}/>
          <div style={{border:"1px solid lightgrey" ,padding:"1px 12px 1px",borderRadius:"2px",marginTop:"-50px",color:"red"}}>
          <input defaultValue={fileA}  style={{border:"none",marginLeft:"84px",background:"transparent",position:"relative"}}/>
           <span style={{border:"1px solid black",backgroundColor:"#efefef",padding:"2px 2px 2px",borderRadius:"2px",position:"absolute",marginTop:"-38px"}}>Choose File</span>
        
           </div></form> <input defaultValue={e.fileName} id="oldEventFound" style={{display:"none"}} />
                          
                          </div>}





                      
                      
                      {/* <input type="file" id="EVimg" onChange={handleFileChange1} placeholder='Event Image' /> */}
                      <span id="EventErrE" className='error'></span>
                    </div>

                  </div>

                  <div className="modal-footer d-flex justify-content-center">
                    <button className='foundation-profile-button' type="submit">Update</button>
                  </div>
                </form>

              </div>
            </div>
          })}

        </div>

      </div>
    </div>


  )
}

export default FoundSectionETMain